import RelatedQuestions from './relatedQuestions'

export { RelatedQuestions }
